var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevron = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0Z",
  "data-name": "Path 245"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6Z",
  "data-name": "Path 246"
})));
export { SvgChevron as ReactComponent };
export default "/_next/static/images/chevron.svg";